import { controls } from "../../controls";
                           
const rp817 = {
  label: "Share Closing Report",
  pageLabel: "Share Closing Report",
  starting: true,
  url: "rp817",
 
  pageType: "history",
  filter: [

      
    
    ...controls.displayText({tab: "filter",label: "As On Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"as_on_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "",width:"col-sm-4 "}),

    ...controls.checkBox({ tab: "filter", label: "Regional Name", name: "regional_name", width: "col-sm-2"}),

   ...controls.displayText({tab: "filter",label: "",width:"col-sm-12 "}),

    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),   
    
      ...controls.displayText({tab: "filter",label: "",width:"col-sm-12 "}),
      
      ...controls.displayText({tab: "filter",label: "Closing Date From-To",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"closing_date_from",width:"col-sm-1"}),    

    ...controls.displayText({tab: "filter",label: "",width:"col-sm-0 "}),
    ...controls.magicDate({tab: "filter",name:"closing_date_from",width:"col-sm-1"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-12 "}),
      
      
  ...controls.displayText({tab: "filter",label: "Opening Date From-To",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"opening_date_from",width:"col-sm-1"}),    
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-0 "}),
    ...controls.magicDate({tab: "filter",name:"opening_date_to",width:"col-sm-1"}),

 ...controls.displayText({tab: "filter",label: "",width:"col-sm-12 "}),
      
      
  ...controls.displayText({ tab: "filter", label: "Gender", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Male",
        value: "male"
      },
      {
        label: "Female",
        value: "female"
      },
      {
        label: "Not Applicable",
        value: "not_applicable"
      }]
    }),

  



  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "Share Closing Report",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      { 
            Header: "Sr",        
            type: "autoinc",
            accessor: "srno",
            width: 30      
      },
    
      

      {
        Header: "Member No",
        accessor: "member_no",
        
      },

            
      {
        Header: "Member Name",
        accessor: "member_name",
        
      },

            
      {
        Header: "Balance",
        accessor: "balance",
        
      },
      
      
    ]
  }
};

export default rp817;